import React from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';
import { Checkbox } from '@blueprintjs/core';
import '@blueprintjs/core/lib/css/blueprint.css';

import FieldWrapper from 'components/common/FieldWrapper';

export default function CategoryCheckboxes({
  categoryOptions,
  arrayInsert,
  arrayRemove,
  categoryOptionsForGroup,
  input,
  input: { name, onChange, onBlur },
  meta,
  selectCategory,
  selectedCategory
}) {
  const findCategoryById = (id) =>
    categoryOptions.find((category) => category.value === id);
  const categoryIds = input.value;

  const checkboxes = categoryOptionsForGroup.map(({ label, value }) => {
    const handleChange = ({ target: { checked } }) => {
      let updatedCategoryIds;
      let indexOfValue;
      let reduxFormArrayMethod;

      const sortByName = (ids) =>
        ids.sort((a, b) => {
          const labelA = findCategoryById(a).label.toUpperCase();
          const labelB = findCategoryById(b).label.toUpperCase();

          if (labelA < labelB) return -1;
          if (labelA > labelB) return 1;
          return 0;
        });

      if (checked) {
        updatedCategoryIds = sortByName([...categoryIds, value]);

        indexOfValue = updatedCategoryIds.indexOf(value);
        reduxFormArrayMethod = arrayInsert;
      } else {
        indexOfValue = categoryIds.indexOf(value);
        reduxFormArrayMethod = arrayRemove;

        updatedCategoryIds = [
          ...categoryIds.slice(0, indexOfValue),
          ...categoryIds.slice(indexOfValue + 1)
        ];

        // This checkbox was deselected
        if (selectedCategory.value === value) {
          selectCategory(findCategoryById(updatedCategoryIds[0]) || {});
        }
      }

      // onBlur fails to get called via the normal DOM event, so calling it here.
      onBlur(updatedCategoryIds);
      reduxFormArrayMethod(
        'partnerSubmissionForm',
        'category_details',
        indexOfValue,
        {
          category_id: value,
          landing_page_urls: [],
          lead_generation_methods: [],
          partner_networks: []
        }
      );
      return onChange(updatedCategoryIds);
    };

    const checked = categoryIds.includes(value);

    return (
      <FieldWrapper
        key={value}
        inputComponent={Checkbox}
        inputComponentProps={{
          className: 'inline',
          onChange: handleChange,
          checked,
          name: `${name}[${value}]`,
          value
        }}
        input={{ value: checked }}
        meta={meta}
        label={label}
        showLabel={false}
        showCheckboxLabel
      />
    );
  });

  return <div>{checkboxes}</div>;
}

CategoryCheckboxes.propTypes = {
  categoryOptions: arrayOf(shape({})).isRequired,
  arrayInsert: func.isRequired,
  arrayRemove: func.isRequired,
  categoryOptionsForGroup: arrayOf(shape({})).isRequired,
  input: shape({
    name: string.isRequired,
    onChange: func.isRequired,
    onBlur: func.isRequired,
    onFocus: func.isRequired
  }),
  meta: shape({}),
  selectCategory: func.isRequired,
  selectedCategory: shape({
    label: string,
    value: number
  }).isRequired
};

CategoryCheckboxes.defaultProps = {
  input: {},
  meta: {}
};
